module.exports = [annotationsNavigationService];

function annotationsNavigationService() {
    var service = {
        scrollToItemByXpath: scrollToItemByXpath
    };

    function scrollToItemByXpath(item, noteId) {
        var contextNode = document.querySelector(noteId + ' .note-html');
        var targetNode = document.evaluate(item.XPath, contextNode, null, XPathResult.FIRST_ORDERED_NODE_TYPE, null).singleNodeValue;
        if (targetNode) {
            targetNode.scrollIntoView({ behavior: 'smooth', block: 'start' });
            temporaryHighlight(targetNode);
        }
        else {
            // console.log('XPath not found: ' + item.XPath);
        }
    }

    function temporaryHighlight(element, duration, transitionTime, highlightColor) {
        if (!highlightColor) {
            highlightColor = "hsl(51, 53%, 76%)";
        }
        if (!transitionTime) {
            transitionTime = "1s";
        }
        if (!duration) {
            duration = 2000;
        }
        element.style.transition = `background-color ${transitionTime} ease`;
        element.style.backgroundColor = highlightColor;

        setTimeout(() => {
            element.style.backgroundColor = "transparent";
        }, duration);
    }

    return service;
}